import {PrimaryButton} from 'packages/common-ui/StyledButton';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import Add from '@material-ui/icons/Add';
import {useEffect, useState} from 'react';
import NewTournament from 'packages/dialogs/new-tournament/NewTournament';
import NewAccount from 'packages/dialogs/NewAccount';
import NewAdmin from 'packages/dialogs/NewAdmin';
import {useModal} from 'packages/hooks/use-modal';
import CreateClub from 'packages/dialogs/CreateClub';

const CreateMenu = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const {toggle: toggleNewTournament, modalOpen: newTournamentOpen} =
    useModal();
  const {toggle: toggleNewAccount, modalOpen: newAccountOpen} = useModal();
  const {toggle: toggleNewAdmin, modalOpen: newAdminOpen} = useModal();
  const {toggle: toggleNewClub, modalOpen: newClubOpen} = useModal();

  const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    setAnchorEl(null);
  }, [newAccountOpen, newAdminOpen, newTournamentOpen, newClubOpen]);

  return (
    <>
      <NewTournament
        toggle={toggleNewTournament}
        modalOpen={newTournamentOpen}
      />
      <CreateClub toggle={toggleNewClub} modalOpen={newClubOpen} />
      <NewAccount toggle={toggleNewAccount} modalOpen={newAccountOpen} />
      <NewAdmin toggle={toggleNewAdmin} modalOpen={newAdminOpen} />
      <PrimaryButton
        startIcon={<Add />}
        style={{marginRight: 10}}
        name="create-btn"
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleOpenMenu}
      >
        Crear
      </PrimaryButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        prefix="menu-create"
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
      >
        <MenuItem onClick={toggleNewTournament}>Nuevo torneo</MenuItem>
        <MenuItem onClick={toggleNewAccount}>Nuevo jugador</MenuItem>
        <MenuItem onClick={toggleNewAdmin}>Nuevo administrador</MenuItem>
        <MenuItem onClick={toggleNewClub}>Nuevo club</MenuItem>
      </Menu>
    </>
  );
};

export default CreateMenu;
